<template>
  <v-container fluid>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">
            {{ $t('EMPLOYEES.ITEM') }} {{ fullName }}
            <v-tooltip v-if="isManuallyType()" top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="error" dark v-bind="attrs" v-on="on">
                  mdi-information-variant-circle-outline
                </v-icon>
              </template>
              <span>{{ $t('EMPLOYEES.M_TYPE_MESSAGE') }}</span>
            </v-tooltip>
          </span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark color="indigo" @click="$router.push({ name: 'employees' })">
          {{ $t('BUTTON.BACK') }}
        </v-btn>
      </v-toolbar>
      <v-divider></v-divider>
    </v-card>
    <v-row class="mt-3">
      <v-col cols="12">
        <employees-main-info-edit v-model="form" @update="setData" />
      </v-col>
      <v-col v-if="!isManuallyType()" cols="12">
        <v-card :loading="loading">
          <v-card-title class="font-weight-regular">
            {{ $t('EMPLOYEES.ABACUS_INFORMATION') }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <employee-abacus-information-form
              :employee="form.abacus_information"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title class="font-weight-regular d-flex align-center">
            <v-row dense>
              <v-col align-self="center">
                {{ $t('REQUEST_VACATIONS.ITEMS') }}
              </v-col>
              <v-spacer />
              <v-col cols="auto" align-self="center">
                <v-subheader
                  v-if="approvedVacations.length"
                  v-text="`${$t('REQUEST_VACATIONS.APPROVED')}:`"
                ></v-subheader>
              </v-col>
              <v-col v-for="(el, key) in approvedVacations" :key="key" cols="1">
                <v-text-field
                  :label="`${el.year}, ${$t('REQUEST_VACATIONS.DAYS')}`"
                  :value="el.days"
                  class="text-field-center"
                  outlined
                  hide-details
                  dense
                  readonly
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <employee-vacation-requests
              :employee-id="id"
              @updated="getVacationRequests"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12">
        <employee-access-mye-reporter v-model="form" @update="setData" />
      </v-col>
      <v-col cols="12">
        <employee-contact-information
          v-model="form"
          @update="setData"
        ></employee-contact-information>
      </v-col>
      <v-col cols="12">
        <employee-additional-information
          v-model="form"
          @update="setData"
        ></employee-additional-information>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import errors from '@/modules/_global/mixins/errors';
import isManuallyType from '@/modules/employees/components/mixins/is-manually-type';
import EmployeeAbacusInformationForm from '../components/forms/EmployeeAbacusInformationForm';
import EmployeeAccessMyeReporter from '../components/EmployeeAccessMyeReporter';
import EmployeeContactInformation from '../components/EmployeeContactInformation';
import EmployeeAdditionalInformation from '../components/EmployeeAdditionalInformation';
import EmployeesMainInfoEdit from '@/modules/employees/components/EmployeesMainInfoEdit';
import { EmployeesService } from '@/services/employees.service';
import EmployeeVacationRequests from '@/modules/employees/components/EmployeeVactionRequests.vue';

export default {
  name: 'EmployeesShowPage',

  components: {
    EmployeeVacationRequests,
    EmployeesMainInfoEdit,

    EmployeeAbacusInformationForm,
    EmployeeAccessMyeReporter,
    EmployeeContactInformation,
    EmployeeAdditionalInformation
  },

  mixins: [errors, isManuallyType],

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    approvedVacations: [],
    unwatch: null,
    form: {
      created_by: null,
      main_information: {},
      user: {},
      abacus_information: {},
      contacts: {},
      additional_information: {}
    }
  }),

  computed: {
    ...mapGetters(['loading']),
    fullName() {
      const first = (this.form.main_information || {}).first_name || '';
      const last = (this.form.main_information || {}).last_name || '';

      return `${first} ${last}`.trim();
    }
  },

  created() {
    this.setData();
    this.unwatch = this.$store.watch(
      state => state.localization.lang,
      () => {
        const lang = this.$store.state.localization.lang;

        if (lang) {
          this.setData();
        }
      }
    );
  },

  destroyed() {
    this.unwatch();
  },

  methods: {
    getVacationRequests() {
      EmployeesService.getApprovedVacations(this.id)
        .then(({ data }) => {
          this.approvedVacations = data;
        })
        .catch(error => {
          this.error = error;
        });
    },
    setData() {
      EmployeesService.getById(this.id).then(({ data }) => {
        this.form = data;
      });
      this.getVacationRequests();
    }
  }
};
</script>

<style scoped>
/deep/ .text-field-center input {
  text-align: center;
  font-weight: bold;
  color: green;
}
</style>
